import React from  'react'

const Badge = ({children}) => {

    return <p className='text-sm px-3 badge'>{ children }</p>

}

export default Badge